module.exports = __webpack_public_path__ + "img/cartbobLogo.8abb1ebd.svg";